import axios from "axios";
import Links from "@/shared/constants/Links";
import stepUpGuard from "@/shared/stepUpGuard";

const base = Links.resultApprovals;

const ResultApprovals = {
  list: (params = {}) => axios.get(base, { params }),
  status: (courseId, semesterId) =>
    axios.get(`${base}/status`, { params: { courseId, semesterId } }),
  listAll: async (params = {}) => {
    const first = await axios.get(base, { params: { ...params, page: 0, size: 100 } });
    const page = first.data;
    if (!page.totalPages || page.totalPages <= 1) return page.content || [];
    const requests = [];
    for (let number = 1; number < page.totalPages; number += 1) {
      requests.push(axios.get(base, { params: { ...params, page: number, size: 100 } }));
    }
    const remaining = await Promise.all(requests);
    return remaining.reduce(
      (items, response) => items.concat(response.data.content || []),
      page.content || []
    );
  },
  get: approvalId => axios.get(`${base}/${approvalId}`),
  history: approvalId => axios.get(`${base}/${approvalId}/history`),
  submitCourse: (courseId, semesterId) =>
    axios.post(`${base}/courses/${courseId}/semesters/${semesterId}/submit`),
  approveDepartmentCourse: (courseId, semesterId, comment) =>
    axios.put(
      `${base}/courses/${courseId}/semesters/${semesterId}/department-approve`,
      comment ? { comment } : {}
    ),
  // Compatibility route for deployed callers. New UI approves by course and semester.
  approveDepartment: (approvalId, comment) =>
    axios.put(`${base}/${approvalId}/department-approve`, comment ? { comment } : {}),
  reject: (approvalId, reason) =>
    axios.put(`${base}/${approvalId}/reject`, { reason }),
  approveStage: (stage, request) =>
    axios.put(`${base}/${stage}/approve`, request),
  rejectStage: (stage, request) =>
    axios.put(`${base}/${stage}/reject`, request),
  moderate: stepUpGuard((courseId, semesterId, request) =>
    axios.put(`${base}/courses/${courseId}/semesters/${semesterId}/moderate`, request)
  )
};

export default ResultApprovals;
